// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3QCS0","buttons":"Footer_buttons__2r2_N"};